/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RemoveAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import Tysiav2Subtract from 'DesignSystem/Svgs/Tysiav2Subtract/index'



/** @type {import('Simple/types.js').View} */
export default function RemoveAction({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters/Letter/RemoveAction"
  
}) {
let letterDocumentNodeIdValueData = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'document_node_id',
})
let letterTaskIdValueData = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'task_id',
})
let aggregateData = fromAggregate.any(letterDocumentNodeIdValueData, letterTaskIdValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let letterDocumentNodeIdValueData1 = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'document_node_id',
})
let letterTaskIdValueData1 = fromData.useDataValue({ viewPath,
context: 'letter',
path: 'task_id',
})
let aggregateData1 = fromAggregate.any(letterDocumentNodeIdValueData1, letterTaskIdValueData1)
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 cursor="pointer"
 paddingLeft={0}
 paddingRight={0}
 onClick={onClick}
 data="letter.document_node_id"
 data="letter.task_id"
 aggregate="/Data/aggregate.js any"
 disabled={aggregateData}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2Subtract
{...childProps}
  viewPath={`${viewPath}/Tysiav2Subtract`}
 fill2={aggregateData1 ? dtColorsNeutral300 : dtColorsNeutral400}
 data="letter.document_node_id"
 data="letter.task_id"
 aggregate="/Data/aggregate.js any"
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}